module.exports = __webpack_public_path__ + "static/shoe-layer-2-effect-360860251d48de0192366afe413c220b.png";